import * as React from "react";

// Utils
import UniversalLink from "§/src/utils/UniversalLink"

// Unternals
import './_tile-content.scss';

// Atoms
import ButtonArrow from "§/src/components/atoms/buttons/button-arrow"


const TileContent = ( props ) => {

  const { pretitle, title, content, cta, template, buttonTemplate, dateRaw, ...atomProps } = props.data;

  var buttonColorClass = (template == 'white') ? 'text-primary' : (template == 'blue') ? 'text-white' : 'text-dark';
  if(buttonTemplate == 'lg-right'){
    var buttonDir = 'top-end';
    var buttonColorClass = buttonColorClass + ' ms-auto icon-lg';
  } else {
    var buttonDir = 'end';
    var buttonColorClass = buttonColorClass + ' me-auto';
  }

  // set atom class
  const atomClassName = 'tile-content temp-' + template;
  var atomClass = props.className != undefined ? atomClassName + ' ' + props.className : atomClassName;

  return (

    <div className={atomClass} { ...atomProps }>
      <div className="card h-100">
        <div className="card-body">
          {pretitle &&
          <span className="card-pretitle fs-9 text-uppercase mb-2 pretitle">{pretitle}</span> }

          {title &&
          <h5 className="card-title h3" dangerouslySetInnerHTML={{__html:title}}/> }

          {content &&
          <p className="card-text">{content}</p> }

          {cta[1] &&
            <UniversalLink
            to={cta}
            className="mt-auto"
            {...(props.noFollow === "true" ? { rel: "nofollow" } : {})}
            >
              <ButtonArrow dir={buttonDir} text={cta[2]} className={buttonColorClass + ' cta stretched-link'}></ButtonArrow>
            </UniversalLink>
          }
        </div>
      </div>
    </div>

  )
}

export default TileContent
